import { Box, CircularProgress, Divider, IconButton, Tooltip, Typography } from '@mui/material'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import SyncIcon from '@mui/icons-material/Sync'
import formatMoney from '../../utils/formatMoney'
import { AUCTION_AREA } from '../../utils/constants'

const FONT_BOLD = 'ITC Officina Sans Std, Bold'
const FONT_BOOK = 'ITC Officina Sans Std, Book'

const AmountItem = ({ label, value, colorClass }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <Typography
      sx={{
        fontFamily: FONT_BOOK,
        fontSize: 12,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        lineHeight: 1,
      }}
    >
      {label}
    </Typography>
    <Typography className={colorClass} sx={{ fontSize: 16, lineHeight: 1 }}>
      {typeof value === 'number' ? formatMoney(value) : '-'}
    </Typography>
  </Box>
)

/**
 * Chip del navbar (escritorio) con la garantía del usuario.
 * Si el usuario es especial y tiene marca, muestra la marca en lugar de los montos.
 * Mientras se actualiza (o aún no hay monto), todo el chip muestra solo un indicador de carga.
 */
const GuaranteeChip = ({ userData, auction, specialMarkLabel, colorClass, onSync }) => {
  const loading = Boolean(userData.loadingUserGuarantee) || (!specialMarkLabel && typeof userData.userGuarantee !== 'number')

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        ml: 1,
        height: 42,
        minWidth: 150,
        pl: 1.75,
        pr: loading ? 1.75 : 0.75,
        borderRadius: 999,
        backgroundColor: '#fff',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.25)',
      }}
    >
      {loading ? (
        <CircularProgress size={22} aria-label="Actualizando garantía" />
      ) : (
        <>
          {specialMarkLabel ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <ShieldOutlinedIcon sx={{ fontSize: 20, color: 'green.main' }} />
              <Typography
                sx={{
                  fontFamily: FONT_BOLD,
                  fontSize: 15,
                  letterSpacing: '0.08em',
                  color: 'primary.main',
                  lineHeight: 1,
                }}
              >
                {specialMarkLabel}
              </Typography>
            </Box>
          ) : (
            <>
              <AmountItem label="Garantía" value={userData.userGuarantee} colorClass={colorClass} />
              {auction.areaId === AUCTION_AREA.PROPIEDADES && (
                <>
                  <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
                  <AmountItem label="Garantía libre" value={userData.freeAmount} colorClass={colorClass} />
                </>
              )}
            </>
          )}
          <Tooltip title="Actualizar garantía" placement="bottom">
            <IconButton
              onClick={onSync}
              size="small"
              sx={{ color: 'primary.main', '&:hover': { backgroundColor: 'rgba(0, 75, 141, 0.08)' } }}
            >
              <SyncIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        </>
      )}
    </Box>
  )
}

export default GuaranteeChip
